import type { MbcAdminCheck } from "@nlc/shared-types";

import { MBC_BRIEF_FIELD_LABELS } from "@nlc/shared-types";
import { useState } from "react";
import { TableBody } from "react-aria-components";

import { Link } from "@/components/link";
import { SearchField, SearchInput } from "@/components/search-field";
import { Cell, Column, Row, Table, TableHeader } from "@/components/table";

interface ChecksTableProps {
  readonly checks: MbcAdminCheck[];
}

export function ChecksTable({ checks }: ChecksTableProps) {
  const [search, setSearch] = useState("");

  const term = search.trim().toLowerCase();
  const visibleChecks = checks.filter((check) =>
    check.label.toLowerCase().includes(term),
  );

  return (
    <div className="flex flex-col gap-4">
      <SearchField aria-label="Search checks">
        <SearchInput
          onChange={(event) => setSearch(event.target.value)}
          onClear={() => setSearch("")}
          placeholder="Search by label"
          value={search}
        />
      </SearchField>

      <div className="rounded-xl border border-border-secondary bg-bg-primary">
        <Table aria-label="Checks">
          <TableHeader>
            <Column defaultWidth="1fr" id="label" isRowHeader minWidth={200}>
              Label
            </Column>
            <Column defaultWidth={160} id="field" minWidth={140}>
              Field
            </Column>
            <Column defaultWidth={120} id="usedBy" minWidth={100}>
              Used by
            </Column>
          </TableHeader>
          <TableBody
            items={visibleChecks}
            renderEmptyState={() => (
              <p className="p-3xl text-sm text-text-tertiary">
                {checks.length === 0
                  ? "No checks yet."
                  : "No check matches this search."}
              </p>
            )}
          >
            {(check) => (
              <Row id={check._id}>
                <Cell>
                  <Link
                    className="block truncate font-medium"
                    href={`/admin/mbc/checks/${check._id}`}
                  >
                    {check.label}
                  </Link>
                </Cell>
                <Cell>{MBC_BRIEF_FIELD_LABELS[check.field]}</Cell>
                <Cell>{check.usedBy.length}</Cell>
              </Row>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
